import React from 'react';

import {
    ThemeProvider, StyledEngineProvider, createTheme, adaptV4Theme
} from '@mui/material/styles';

import { Provider } from 'react-redux';
import PropTypes from 'prop-types';

import { I18nextProvider } from 'react-i18next';
import { ReactKeycloakProvider } from '@react-keycloak/web';

import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';
import Main from '../Shared/Main';
import i18n from '../../i18n';

import keycloak from '../../keycloak-config';
import PersistentStorage from '../../services/storage';
import { COLORS } from '../../utils';
import GeneralProgressBar from '../Shared/GeneralProgressBar';
import { history } from '../../history';

const theme = createTheme(adaptV4Theme({
    palette: {
        primary: {
            main: COLORS.primary.main
        },
        secondary: {
            main: COLORS.secondary.main
        },
        accent: {
            main: COLORS.accent.main,
            second: COLORS.accent.second,
            third: COLORS.accent.third
        },
        error: {
            main: COLORS.error.main,
            dark: COLORS.error.dark
        }
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 960,
            mdp: 1180,
            lg: 1280,
            xl: 1920
        }
    },
    typography: {
        useNextVariants: true,
        fontFamily: '\'DM Sans\', Roboto, Helvetica, Arial, sans-serif',
    },
    overrides: {
        MuiButton: {
            root: {
                fontWeight: '600'
            },
            label: {
                position: 'relative',
                top: '1.2px',
            },
        },
        MuiTableRow: {
            root: {
                height: '45px'
            }
        }
    }
}));

const App = ({ store }) => {

    const keycloakEventHandler = event => {
        if (event === 'onAuthRefreshError') {
            PersistentStorage.setItem('logout', Date.now());
            keycloak.logout();
        }
    };

    return (
        <Provider store={store}>
            <HistoryRouter history={history}>
                <I18nextProvider i18n={i18n}>
                    <StyledEngineProvider injectFirst>
                        <ThemeProvider theme={theme}>
                            <ReactKeycloakProvider
                                authClient={keycloak}
                                initOptions={{
                                    onLoad: 'login-required',
                                }}
                                onEvent={keycloakEventHandler}
                            >
                                <React.Suspense fallback={<GeneralProgressBar />}>
                                    <Main />
                                </React.Suspense>
                            </ReactKeycloakProvider>
                        </ThemeProvider>
                    </StyledEngineProvider>
                </I18nextProvider>
            </HistoryRouter>
        </Provider>
    );
};

App.propTypes = {
    store: PropTypes.object
};

export default App;
